// Copyright (c) Docugami, Inc. All rights reserved.

/**
 * List of all messages supported by the MessageBus
 */
export enum MessageId {
    SelectionModeActionConfirm = 'SelectionModeActionConfirm',
    SelectionModeActionCancel = 'SelectionModeActionCancel',
    SelectionModeProviderRequest = 'SelectionModeProviderRequest',
    SelectionModeProviderResponse = 'SelectionModeProviderResponse',
    ChunkResizeEvent = `ChunkResizeEvent`,
    AdvanceWorkPathStep = 'AdvanceWorkPathStep',
    TextEdit = 'TextEdit'
}

/**
 * Base interface implemented by all messages
 */
export interface IMessage {
    id: MessageId
}
